import React, { MouseEventHandler, ReactNode } from 'react';
import styled from 'styled-components';
import {
  BorderProps,
  LayoutProps,
  MarginProps,
  PaddingProps,
} from 'styled-system';

import Link from 'components/Link';
import { Link as RouterLink } from 'components/RouterLink';
import { SmallTile } from 'components/Tile';

import { colors, transition } from '../theme';

export const OverlayRouterLink = styled(RouterLink)`
  &,
  &:active,
  &:visited {
    color: inherit;
    text-decoration: none;
  }
  ::after {
    z-index: 0;
    position: absolute;
    content: '';
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
  }
`;
export const OverlayLink = styled(Link)`
  &,
  &:active,
  &:visited,
  &:hover {
    color: inherit;
    text-decoration: none;
  }
  ::after {
    z-index: 0;
    position: absolute;
    content: '';
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
  }
`;
export const HoverEffect = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 5px;
  overflow: hidden;
  border-radius: 4px 0 0 4px;
  &::before {
    content: '';
    width: 100%;
    height: 100%;
    display: block;
    background: linear-gradient(to left, ${colors.lemon}, ${colors.marigold});
    transition: all ${transition};
  }
`;
const SearchTile = styled(
  ({
    children,
    ...props
  }: {
    children?: ReactNode;
    disabled?: boolean;
    className?: string;
    onClick?: MouseEventHandler;
  }) => (
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/jsx-props-no-spreading
    <SmallTile {...props}>
      <HoverEffect />
      {children}
    </SmallTile>
  )
)<MarginProps & PaddingProps & LayoutProps & BorderProps>`
  overflow: visible;
  ${(props) =>
    !props.disabled
      ? `
  cursor: pointer;
  ${HoverEffect} {
    &::before {
      transform: translateY(-100%);
    }
  }
  &:hover,
  &:focus {
    ${HoverEffect} {
      &::before {
        transform: translateY(0);
      }
    }
  }`
      : `
    background: transparent;
    box-shadow: 0 0 0 1px ${colors.aluminum};
  `}
`;
export default SearchTile;
